package com.gsb.vyapar.bhagya.datasource.network.response

import kotlinx.serialization.Serializable

@Serializable
data class AuthResponse(
    val idToken: String? = null,
    val email: String? = null,
    val refreshToken: String? = null,
    val expiresIn: String? = null,
    val localId: String? = null,
    val displayName: String? = null,
    val registered: Boolean? = null
)